<template>
    <div>
         <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="time">
                <el-input v-model="pgData.bdcode"  placeholder="标段编号" clearable></el-input>
            </el-form-item>
             <el-form-item slot="title">
                 <el-input v-model="pgData.bdname"  placeholder="标段名称" clearable></el-input>
            </el-form-item>
        </my-search>

        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段编号" prop="bdcode"  fixed min-width="150"></el-table-column>
            <el-table-column label="标段名称" prop="bdname"  min-width="150"></el-table-column>
            <el-table-column label="状态" prop="shbj" width="150">
                 <template slot-scope="scope">
                   <span v-if="scope.row.shbj==='0'">
                        <my-tag type="danger" >未提交</my-tag>
                   </span>
                    <span v-if="scope.row.shbj==='1'">
                        <my-tag type="primary" >已提交</my-tag>
                   </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                    <el-button
                    type="text"
                    icon="el-icon-warning"
                    @click="editHandler({bdcode:scope.row.bdcode})">
                        退回
                    </el-button>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('mngUrl')}/Zbdl/tuihui/get_kbjlList.json`">
        </my-pagination>

        <my-dialog 
        title="退回" 
        v-model="dialogVisible" 
        width="500px"
        >
            <form-page 
                v-if="dialogVisible"
                :data="form"
                @cancle="dialogClose"
            ></form-page>
        </my-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

import FormPage from './form'

export default {
    mixins: [LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN],
    components: { FormPage },
    data() {
        return {
            pgData: {
                sortname: 'addtime',
                sortorder: 'desc',
                pagesize: 20,
                bdcode:'',
                bdname:''

            },

            form: {}
        }
    },
    methods: {
        
    },
    created() {
       
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
</style>
